import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';

export type UpdateInternationalPaymentResponseType = {
  id: string;
  date_created: string;
  date_modified: string;
  recipient_name: string;
  bank_swift_code: string;
  bank_name: string;
  bank_account_number: string;
  bank_address: string;
  bank_phone_number: string;
  intermediary_bank_swift_code?: string;
  intermediary_bank_name?: string;
  intermediary_bank_account_number?: string;
  intermediary_bank_address?: string;
  intermediary_bank_phone_number?: string;
};

export type UpdateInternationalPaymentDetailsPayloadType = Omit<
  UpdateInternationalPaymentResponseType,
  'id' | 'date_created' | 'date_modified'
>;

export const updateWirePaymentDetailsInternationalApi = (
  wireId: string,
  data: UpdateInternationalPaymentDetailsPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<UpdateInternationalPaymentResponseType>> => {
  const uri = `/recipient/wires/${wireId}/payment-details/international/`;

  return authApiService.POST(uri, data, null, options);
};
